/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { PageStringSection } from "./pageStringSection";

export class General extends PageStringSection {
    error_NotAuthorized: string = "You are not authorized to access this resource";
    error_Unexpected: string = "Messages.msg_Error_Unexpected";
    error_InvalidRequest: string = "Invalid request";
    message_Saved: string = "Labels.lbl_Saved";
    message_SelfAccountCreation_Success: string = "Messages.msg_AccountSelfCreationSuccess";
    message_SelfAccountCreation_ApprovalPending: string = "Messages.msg_AccountSelfCreationSuccessApprovalPending";
}
